<Comment
  comment={$moveListRow.content}
  className={`move-list-row comment-row ${bgColorClass}`}
/>

<svelte:options immutable/>

<script lang="ts">
import type { MoveListComponent } from 'components/move-list/config/types';
import Comment from 'components/move-list/components/comment.svelte';
import type { Data } from 'src/utils/svelte/data';

export let moveListRow: Data<MoveListComponent.Row<MoveListComponent.Comment>>;

$: bgColorClass = $moveListRow.rowBgColor ?? 'light-row';
</script>
